import React, { useEffect, useState } from 'react'
import { getComentInfoAPI } from '../../Api/SupplierServices'
import CommentList from '../../Components/CommentList/CommentList'
import LoadingComponet from '../../Components/LoadingComponet/LoadingComponet'
import MenuTitle from '../../Components/MenuTitlle/MenuTitle'
import Style from './ManageComments.module.css'
const ManageComments = () => {

    const[CommentDetails,setCommentDetails]=useState()

    useEffect(()=>{
        getCommentDetail()
    },[])

    const getCommentDetail=async()=>{
        const data=await getComentInfoAPI()
        setCommentDetails(data)
    }

    let loadingHolder=null
    if(CommentDetails===undefined){
        loadingHolder=<LoadingComponet/>
    }
    else{
        loadingHolder=<CommentList data={CommentDetails.comments} updateList={getCommentDetail}/>
    }
    return (
        <div className={Style.PageHolder}>
            <MenuTitle title={'مدیریت نظرات'}/>
            <section className={Style.TotalScore}>
                <div className={Style.Rate}><p>:امتیاز سفارش ها</p> <span>{CommentDetails===undefined?'درحال محاسبه':CommentDetails.average===null?0:Math.round(CommentDetails.average * 10) / 10}</span></div>
                <div className={Style.counter}><p>:تعداد نظرات ثبت شده</p> <span>{CommentDetails===undefined?'درحال محاسبه':CommentDetails.count}</span></div>
            </section>
            {
                loadingHolder
            }
        </div>
    )
}

export default ManageComments
